// extracted by mini-css-extract-plugin
export var articleMask = "style-module--articleMask--f94a2";
export var benefit = "style-module--benefit--49ef4";
export var buttonContainer = "style-module--buttonContainer--40d6f";
export var enable = "style-module--enable--7d8b2";
export var limit = "style-module--limit--e6906";